import React from 'react';
import styles from '../../assets/styles/styles.less';
import MediaQuery from 'react-responsive';

import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { hashHistory } from 'react-router';

import PaymentMobile from './PaymentMobile';
import { Loading } from '../Controls';

import { paymentFieldOnChange, paymentFieldOnBlur } from '../../actions/actions.js';


class Payment extends React.Component {

    componentWillMount(){
        const { reducer } = this.props;
        if (!reducer 
        || reducer.success   // submitted already    
        || Object.keys(reducer.charity).length === 0 // no charity
        || !reducer.target.valid // no target data or no personal data
        || !reducer.personal.valid) hashHistory.push('/');
    }
	
    render() {
        return (
            <div>
                <PaymentMobile {...this.props} />
                { this.props.reducer.loading ? <Loading /> : null }
            </div> 
        )
    }

};

function mapStateToProps(state) {
  return {
    reducer: state.detailsReducer
  }
};

function matchDispatchToProps(dispatch) {
  return bindActionCreators({
    paymentFieldOnChange,
    paymentFieldOnBlur 
}, dispatch)
};

export default connect(mapStateToProps, matchDispatchToProps)(Payment);


// WEBPACK FOOTER //
// ./components/Payment/Payment.js